import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import { displayMultiSelect } from "../Utility/ChipDisplay";
import QAComplaintsFiltersDialog from "./QAComplaintsFiltersDialog";

interface IComplaintsFiltersProps {
    isAgent: boolean;
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function QAComplaintsFilters({ callTableViewModel, setCallTableViewModel, isAgent }: IComplaintsFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'QA Actions'
            }
            {
                callTableViewModel.filters.qaComplaintsFilters.qaComplaintType ? ` - ${callTableViewModel.filters.qaComplaintsFilters.qaComplaintType}` : ''
            }
            {
                displayMultiSelect(callTableViewModel.filters.qaComplaintsFilters.qaComplaint, 'Categories')
            }
            {
                displayMultiSelect(callTableViewModel.filters.qaComplaintsFilters.originator, 'Originators')
            }
            {
                displayMultiSelect(callTableViewModel.filters.qaComplaintsFilters.outcome, 'Outcomes')
            }
            {
                callTableViewModel.filters.qaComplaintsFilters.searchLoggedDate ? ` - Searching Logged Date` : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <QAComplaintsFiltersDialog
                isAgent={isAgent}
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}